<template>
  <VcBanner
    v-show="!hideBanner"
    class="upsell-payment-banner"
    :data-qa="dataQa"
    :title="$t('upsell_payment_banner.title')"
    :subtitle="$t('upsell_payment_banner.subtitle')"
    :button-label="$t('upsell_payment_banner.upgrade_now')"
    :link-label="helpLinkLabel"
    :link-url="helpLinkUrl"
    :image="paymentsGenericImage"
    background-color="#FFFFFF"
    :close-button="showCloseButton"
    @onAction="handleUpgradeAction"
    @linkClick="handleLinkClick"
    @closeBanner="hideBanner = true"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import paymentsGenericImage from '@/assets/images/payments/payments-generic.svg';
import outgoingPostMessageUtils from '@/utils/eventCommunicationUtils/outgoingPostMessageUtils';
import { routeHelpLinkClick } from '@/modules/help/services/helpEntryService';

export default {
  name: 'UpsellPaymentBanner',
  props: {
    showCloseButton: {
      type: Boolean,
      default: false,
    },
    dataQa: {
      type: String,
      default: 'upsell-payment-banner',
    },
    source: {
      type: String,
      default: 'unknown',
    },
  },
  data() {
    return {
      hideBanner: false,
      paymentsGenericImage,
    };
  },
  async mounted() {
    // Load upsell payment banner translations after mounting
    await this.addI18nModule('upsell-payment-banner-pov');
  },
  computed: {
    ...mapGetters('BusinessStore', ['supportArticleUrl']),
    isThryvAccount() {
      return this.$hasFeature('show_variant_learn_more_link');
    },
    linkUrl() {
      const link = this.supportArticleUrl('Online_Payments');
      const fallbackLink = this.isThryvAccount ? '' : 'https://support.myclients.io/hc/en-us/articles/360039687694-Accepting-Online-Payments';
      return link || fallbackLink;
    },
    helpLinkUrl() {
      return this.linkUrl;
    },
    helpLinkLabel() {
      return this.$t('upsell_payment_banner.learn_more');
    },
  },
  methods: {
    handleUpgradeAction() {
      this.$track('Upsell Banner - Upgrade Clicked', { source: this.source });
      outgoingPostMessageUtils.post('open-upgrade-page', this.source);
    },
    handleLinkClick(event) {
      const destination = routeHelpLinkClick(event, {
        message: this.$t('upsell_payment_banner.learn_more_question'),
        source: this.source,
      });
      this.$track('help_article_clicked', {
        'Article Code': 'online_payments_banner',
        source: this.source,
        destination,
      });
      this.$emit('onLinkClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.upsell-payment-banner {
  margin-block-end: var(--size-value6);
}
</style>
